import React from 'react';

// --- IMPORTANT ---
// You MUST import your images. Replace these paths with your own.
import Blue from "../updatehackinginternship/Assets/ProcessAssets/blue.png";
import Blue1 from "../updatehackinginternship/Assets/ProcessAssets/14i86yrnf1m9corm5g.png";
import yellow from "../updatehackinginternship/Assets/ProcessAssets/yellow.png";
import yellow1 from "../updatehackinginternship/Assets/ProcessAssets/yellow1.png";
import green from "../updatehackinginternship/Assets/ProcessAssets/green.png";
import green1 from "../updatehackinginternship/Assets/ProcessAssets/greenmob.png";
import com from "../updatehackinginternship/Assets/ProcessAssets/Computer.png";
import person from "../updatehackinginternship/Assets/ProcessAssets/person.png";
import edu from "../updatehackinginternship/Assets/ProcessAssets/education.png";
import GreenBorderline from "../updatehackinginternship/Assets/ProcessAssets/skgreenborder.png";

function WhoShouldJoinSection() {
  return (
    <div>
      <style>{`
        .kraft-header {
            text-align: center;
            margin: 3em 0 4em 0;
        }

        .kraft-header h1 {
            font-size: 36px;
            color: #333;
            position: relative;
            display: inline-block;
            padding-bottom: 15px; /* Creates space for the underline image */
        }
        
        /* This is the new class for your underline image */
        .kraft-header-underline {
          display: block;
          margin: 0 auto; /* Centers the image */
          width: 250px;
          height: 8.59px;
          margin-top: -15px; /* Pulls the image up */
        }

        .kraft-body {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1.5em;
        }

        .kraft-card {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 365px;
          height: 300px;

          background-repeat: no-repeat !important;
          background-size: cover !important;
          background-position: center !important;
          background-image: var(--bg-desktop);

          text-align: center;
          box-shadow: none;
          transition: transform 0.2s ease-in-out;
        }

        .kraft-card:hover {
          transform: translateY(-5px);
        }

        .kraft-top {
          margin-bottom: 0.8em;
        }

        .kraft-title {
          color: #333;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 0.5em;
        }

        .kraft-bottom {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.2em;
        }

        .kraft-desc {
          color: #555;
          font-size: 15px;
          line-height: 1.5;
          max-width: 260px;
        }

        .kraft-img {
          max-height: 80px;
          max-width: 100px;
          object-fit: contain;
        }

        @media screen and (max-width: 800px) {
          .kraft-body {
            align-items: center;
            gap: 1.5rem;
          }

          .kraft-card {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            width: 332px;
            height: 95px;
            padding: 1em 2.6em;
            background-size: contain !important;
            background-position: center right !important;
            background-image: var(--bg-mobile);
          }

          .kraft-card .kraft-top,
          .kraft-card .kraft-bottom {
            margin: 0;
          }

          .kraft-card .kraft-title {
            display: flex;
            font-size: 16px;
          }

          .kraft-card .kraft-desc {
            font-size: 13px;
            text-align: left;
            max-width: 180px;
            padding: 0;
          }

          .kraft-card .kraft-img {
            max-height: 60px;
            max-width: 70px;
          }

          .kraft-card:not(:last-child) {
            margin-right: 0;
            gap: 2em;
          }
        }
      `}</style>

      {/* CORRECTION: The underline image is now INSIDE the header div 
        and uses a class instead of inline styles.
      */}
      <div className="kraft-header">
        <h1>Who Should Join This Ethical Hacking Course</h1>
        <img
          className="kraft-header-underline"
          src={GreenBorderline}
          alt="GreenBorderline"
        />
      </div>
     
      <div className="kraft-body">
        <div
          className="kraft-card"
          style={{
            "--bg-desktop": `url(${yellow1})`,
            "--bg-mobile": `url(${yellow})`,
          }}
        >
          <div className="kraft-top">
            <div className="kraft-title">Students</div>
            <div className="kraft-desc">
              Ideal for Computer Science, IT field graduates.
            </div>
          </div>
          <div className="kraft-bottom">
            <img className="kraft-img" src={edu} alt="education" />
          </div>
        </div>

        <div
          className="kraft-card"
          style={{
            "--bg-desktop": `url(${Blue})`,
            "--bg-mobile": `url(${Blue1})`,
          }}
        >

          <div className="kraft-top">
            <div className="kraft-title">IT Professionals</div>
            <div className="kraft-desc">
              SysAdmins, Network Engineers looking to specialize.
            </div>
          </div>
          <div className="kraft-bottom">
            <img className="kraft-img" src={com} alt="computer" />
          </div>
        </div>

        <div
          className="kraft-card"
          style={{
            "--bg-desktop": `url(${green})`,
            "--bg-mobile": `url(${green1})`,
          }}
        >
          <div className="kraft-top">
            <div className="kraft-title">Curious Problem-Solvers</div>
            <div className="kraft-desc">
              A strong passion for technology and think like an attacker.
            </div>
          </div>
          <div className="kraft-bottom">
            <img className="kraft-img" src={person} alt="person" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhoShouldJoinSection;